import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { OrgBasedOnboardForm } from '../shared/service/IorgBasedForms';
import { ValidationConstants as validationConstants } from '../constants/validation-constants';
import { FileConstants } from '../constants/file-constants';

@Injectable()
export class OnboardFormsUtil {

    constructor(private formBuilder: FormBuilder) { }

    initializeForm() {
        return this.formBuilder.group({
            flag: new FormControl(''),
            id: new FormControl(''),
            orgid: new FormControl(''),
            status: new FormControl(''),
            appid: new FormControl(''),
            //basic info screen
            salutation: new FormControl(''),
            fname: new FormControl(''),
            firstname: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(30)]),
            middlename: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(30)]),
            lastname: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(30)]),
            gender: new FormControl(''),
            maritalstatus: new FormControl(''),
            dob: new FormControl(''),
            age: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.max(60)]),
            nationality: new FormControl(''),
            email: new FormControl('', [Validators.email]),
            dialcode: new FormControl('', [Validators.required]),
            mobilenumber: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.minLength(4), Validators.maxLength(15)]),
            mobino: new FormControl(''),
            altdialcode: new FormControl(''),
            altemail: new FormControl('', [Validators.email]),
            altmobilenumber: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(15)]),
            altermobino: new FormControl(''),
            bloodgroup: new FormControl('',),
            hobbies: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(20)]),
            created_by: new FormControl(''),
            createdon: new FormControl(''),
            modified_by: new FormControl(''),
            modifiedby: new FormControl(''),
            modified_on: new FormControl(''),
            currentctc: new FormGroup({
                value: new FormControl(null),
                type: new FormControl(''),
            }),
            expctc: new FormGroup({
                value: new FormControl(null),
                type: new FormControl(''),
            }),
            funarea: new FormControl(''),
            subfunarea: new FormControl(''),
            substatus: new FormControl(''),
            source: new FormControl(''),
            sourcedetails: new FormControl(''),
            keyskill: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]),
            //Languages
            language: this.formBuilder.array([]), // FormArray
            candidatedata: new FormGroup({
                //experience
                experience: this.formBuilder.array([]), // FormArray
                //education
                education: this.formBuilder.array([]), // FormArray
                //skills
                skills: this.formBuilder.array([]), // FormArray
            }),
            //Identity Details
            identity: new FormGroup({
                ssn_no: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(9)]),
                passport_no: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(9)]),
                pancard_no: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(10)]),
                drivinglicense_no: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(16)])
            }),
            //Financial Details 
            bank: new FormGroup({
                bankname_1: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6)]),
                bankaccountno_1: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(30)]),
                ifsc_code_1: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(11)]),
                bankname_2: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6)]),
                bankaccountno_2: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(30)]),
                ifsc_code_2: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(11)]),
                bankname_3: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6)]),
                bankaccountno_3: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(30)]),
                ifsc_code_3: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(11)])
            }),
            //Address
            curaddline1: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(30)]),
            permaddline1: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(30)]),
            curaddline2: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]),
            permaddline2: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]),
            curtcity: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(100)]),
            permcity: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(100)]),
            curtstate: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(100)]),
            permstate: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(100)]),
            curpin: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(10)]),
            permpin: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(10)]),
            curcountry: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(50)]),
            permcountry: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(50)]),
            //eme contact 
            emecontactname: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
            emerel: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
            emedialcode: new FormControl(''),
            ememobilenumber: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.minLength(4), Validators.maxLength(15)]),
            emenum: new FormControl(''),
            //Reference 
            reference: this.formBuilder.array([]), // FormArray
            //Family 
            family: new FormGroup({
                //Father
                father_name: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                father_dob: new FormControl(''),
                father_gender: new FormControl('Male'),
                father_address: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)]),
                // Mother
                mother_name: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                mother_dob: new FormControl(''),
                mother_gender: new FormControl('Female'),
                mother_address: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)]),
                //Spouse
                spouse_name: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                spouse_dob: new FormControl(''),
                spouse_gender: new FormControl(''),
                spouse_address: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)]),
                // Father-in-law
                fatherinlaw_name: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                fatherinlaw_dob: new FormControl(''),
                fatherinlaw_gender: new FormControl('Male'),
                fatherinlaw_address: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)]),
                // Mother-in-law
                motherinlaw_name: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                motherinlaw_dob: new FormControl(''),
                motherinlaw_gender: new FormControl('Female'),
                motherinlaw_address: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)]),
                // Siblings
                siblings: this.formBuilder.array([]), // FormArray
                //Children
                children: this.formBuilder.array([]) // FormArray
            }),
            //Declarations
            decmedi: new FormControl(''),
            decrelwork: new FormControl(''),
            decworkprev: new FormControl(''),
            declaration: new FormGroup({
                workedpreviouslydetails: new FormGroup({
                    dept_company: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                    empid: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(20)]),
                    designation: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                    ctc: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(18)]),
                    ctctype: new FormControl(''),
                    dateofrelieving: new FormControl(''),
                    reason: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                    supervisor_name: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                    supervisor_empid: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(20)]),
                    supervisor_designation: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                    supervisor_email: new FormControl('', [Validators.email]),
                    supervisor_dialcode: new FormControl(''),
                    supervisor_mobilenumber: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(15)]),
                    supervisor_mobino: new FormControl('')
                }),
                // relative
                relativeworkingdetails: this.formBuilder.array([]), // FormArray
                // medical 
                medicalailmentsdetails: new FormGroup({
                    description: new FormControl('', [Validators.maxLength(250)])
                }),
            }),
            //Files
            compensationdetails: new FormGroup({
                latestsalarybreakup: new FormControl(''),
                bonuspayoutform: new FormControl(''),
                bankstatement: new FormControl(''),
                payslip1: new FormControl(''),
                payslip2: new FormControl(''),
                payslip3: new FormControl(''),
            }),
            forms: new FormGroup({
                employmentapplicationform: new FormControl(''),
                bgvform: new FormControl(''),
                joiningform: new FormControl(''),
                pfuan: new FormControl(''),
                medicalreport: new FormControl(''),
                conflictofinterestform: new FormControl(''),
                confidentialityform: new FormControl(''),
            }),
            idattachments: new FormGroup({
                pancard: new FormControl(''),
                ssn: new FormControl(''),
                photograph: new FormControl(''),
                passport: new FormControl(''),
                pancardmultipart: new FormControl(''),
                ssnmultipart: new FormControl(''),
                photographmultipart: new FormControl(''),
                passportmultipart: new FormControl(''),
                pancardtemploc: new FormControl(''),
                ssntemploc: new FormControl(''),
                photographtemploc: new FormControl(''),
                passporttemploc: new FormControl(''),
            }),
            eduexpattachments: new FormGroup({
                educationproof: this.formBuilder.array([]), // FormArray
                experienceproof: this.formBuilder.array([]) // FormArray
            }),
            resumeuploadkey: new FormControl(null),
            profilepicuploadkey: new FormControl(null),
            summary: new FormControl('', [Validators.maxLength(500)]),
            totexp: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.max(45)]),
            relexp: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.max(45)]),
            // reasonchange: new FormControl('', [Validators.maxLength(250)]),
            noticeperiod: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.max(90)]),
            joindur: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(3)]),
            designation: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
            resumeuploaded: new FormControl(''),
            prefloc: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(50)]),
            militaryveteran: new FormControl(''),
            remarks: new FormControl('', [Validators.maxLength(500)]),
            highesteducation: new FormControl(''),
            currentemployer: new FormControl(''),
            specialization: new FormControl(''),
            yearofpassing: new FormControl(''),
            sameascurrentaddress: new FormControl(''),
        });
    }

    initializeDocumentForm() {
        return this.formBuilder.group({
            flag: new FormControl(''),
            id: new FormControl(''),
            orgid: new FormControl(''),
            status: new FormControl(''),
            appid: new FormControl(''),
            //basic info screen
            salutation: new FormControl(''),
            fname: new FormControl(''),
            firstname: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(30)]),
            middlename: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(30)]),
            lastname: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(30)]),
            gender: new FormControl(''),
            maritalstatus: new FormControl(''),
            dob: new FormControl(''),
            age: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.max(60)]),
            nationality: new FormControl(''),
            email: new FormControl('', [Validators.email]),
            dialcode: new FormControl('', [Validators.required]),
            mobilenumber: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.minLength(4), Validators.maxLength(15)]),
            mobino: new FormControl(''),
            altdialcode: new FormControl(''),
            altmobilenumber: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(15)]),
            altermobino: new FormControl(''),
            bloodgroup: new FormControl(''),
            hobbies: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(20)]),
            created_by: new FormControl(''),
            createdon: new FormControl(''),
            modified_by: new FormControl(''),
            modifiedby: new FormControl(''),
            modified_on: new FormControl(''),
            currentctc: new FormGroup({
                value: new FormControl(null),
                type: new FormControl(''),
            }),
            expctc: new FormGroup({
                value: new FormControl(null),
                type: new FormControl(''),
            }),
            funarea: new FormControl(''),
            subfunarea: new FormControl(''),
            substatus: new FormControl(''),
            source: new FormControl(''),
            sourcedetails: new FormControl(''),
            keyskill: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]),
            //Languages
            language: this.formBuilder.array([]), // FormArray
            candidatedata: new FormGroup({
                //experience
                experience: this.formBuilder.array([]), // FormArray
                //education
                education: this.formBuilder.array([]), // FormArray
                //skills
                skills: this.formBuilder.array([]), // FormArray
            }),
            //Identity Details
            identity: new FormGroup({
                ssn_no: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(9)]),
                passport_no: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(9)]),
                pancard_no: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(10)]),
                drivinglicense_no: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(16)])
            }),
            //Financial Details 
            bank: new FormGroup({
                bankname_1: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6)]),
                bankaccountno_1: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(30)]),
                ifsc_code_1: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(11)]),
                bankname_2: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6)]),
                bankaccountno_2: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(30)]),
                ifsc_code_2: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(11)]),
                bankname_3: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6)]),
                bankaccountno_3: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(30)]),
                ifsc_code_3: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(11)])
            }),
            //Address
            curaddline1: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(30)]),
            permaddline1: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(30)]),
            curaddline2: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]),
            permaddline2: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]),
            curtcity: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(100)]),
            permcity: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(100)]),
            curtstate: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(100)]),
            permstate: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(100)]),
            curpin: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(10)]),
            permpin: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(10)]),
            curcountry: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(50)]),
            permcountry: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(50)]),
            //eme contact 
            emecontactname: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
            emerel: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
            emedialcode: new FormControl(''),
            ememobilenumber: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.minLength(4), Validators.maxLength(15)]),
            emenum: new FormControl(''),
            //Reference 
            reference: this.formBuilder.array([]), // FormArray
            //Family 
            family: new FormGroup({
                //Father
                father_name: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                father_dob: new FormControl(''),
                father_gender: new FormControl('Male'),
                father_address: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)]),
                // Mother
                mother_name: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                mother_dob: new FormControl(''),
                mother_gender: new FormControl('Female'),
                mother_address: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)]),
                //Spouse
                spouse_name: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                spouse_dob: new FormControl(''),
                spouse_gender: new FormControl(''),
                spouse_address: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)]),
                // Father-in-law
                fatherinlaw_name: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                fatherinlaw_dob: new FormControl(''),
                fatherinlaw_gender: new FormControl('Male'),
                fatherinlaw_address: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)]),
                // Mother-in-law
                motherinlaw_name: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                motherinlaw_dob: new FormControl(''),
                motherinlaw_gender: new FormControl('Female'),
                motherinlaw_address: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)]),
                // Siblings
                siblings: this.formBuilder.array([]), // FormArray
                //Children
                children: this.formBuilder.array([]) // FormArray
            }),
            //Declarations
            decmedi: new FormControl(''),
            decrelwork: new FormControl(''),
            decworkprev: new FormControl(''),
            declaration: new FormGroup({
                workedpreviouslydetails: new FormGroup({
                    dept_company: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                    empid: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(20)]),
                    designation: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                    ctc: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(18)]),
                    ctctype: new FormControl(''),
                    dateofrelieving: new FormControl(''),
                    reason: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                    supervisor_name: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                    supervisor_empid: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(20)]),
                    supervisor_designation: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                    supervisor_email: new FormControl('', [Validators.email]),
                    supervisor_dialcode: new FormControl(''),
                    supervisor_mobilenumber: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(15)]),
                    supervisor_mobino: new FormControl('')
                }),
                // relative
                relativeworkingdetails: this.formBuilder.array([]), // FormArray
                // medical 
                medicalailmentsdetails: new FormGroup({
                    description: new FormControl('', [Validators.maxLength(250)])
                }),
            }),
            //Files
            compensationdetails: new FormGroup({
                latestsalarybreakup: new FormControl(''),
                bonuspayoutform: new FormControl(''),
                bankstatement: new FormControl(''),
                payslip1: new FormControl(''),
                payslip2: new FormControl(''),
                payslip3: new FormControl(''),
            }),
            forms: new FormGroup({
                employmentapplicationform: new FormControl(''),
                bgvform: new FormControl(''),
                joiningform: new FormControl(''),
                pfuan: new FormControl(''),
                medicalreport: new FormControl(''),
                conflictofinterestform: new FormControl(''),
                confidentialityform: new FormControl(''),
            }),
            idattachments: new FormGroup({
                pancard: new FormControl(''),
                ssn: new FormControl(''),
                photograph: new FormControl(''),
                passport: new FormControl(''),
                pancardmultipart: new FormControl(''),
                ssnmultipart: new FormControl(''),
                photographmultipart: new FormControl(''),
                passportmultipart: new FormControl(''),
                pancardtemploc: new FormControl(''),
                ssntemploc: new FormControl(''),
                photographtemploc: new FormControl(''),
                passporttemploc: new FormControl(''),
            }),
            eduexpattachments: new FormGroup({
                educationproof: this.formBuilder.array([]), // FormArray
                experienceproof: this.formBuilder.array([]) // FormArray
            }),
            resumeuploadkey: new FormControl(null),
            profilepicuploadkey: new FormControl(null),
            summary: new FormControl('', [Validators.maxLength(500)]),
            totexp: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.max(45)]),
            relexp: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.max(45)]),
            // reasonchange: new FormControl('', [Validators.maxLength(250)]),
            noticeperiod: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.max(90)]),
            joindur: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(3)]),
            designation: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
            resumeuploaded: new FormControl(''),
            prefloc: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(50)]),
            militaryveteran: new FormControl(''),
            remarks: new FormControl('', [Validators.maxLength(500)]),

        });
    }

    addNewLanguagesFormArrayField(orgBasedOnboardFormsJson: OrgBasedOnboardForm) {
        // if (orgBasedOnboardFormsJson.languagesFieldIsRequired) {
        return this.formBuilder.group({
            // language: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE1), Validators.maxLength(30)]),
            language: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(30)]),
            read: new FormControl(''),
            write: new FormControl(''),
            speak: new FormControl(''),
        });
        // }
        // else {
        //     return this.formBuilder.group({
        //         language: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE1), Validators.maxLength(30)]),
        //         read: new FormControl(''),
        //         write: new FormControl(''),
        //         speak: new FormControl(''),
        //     });
        // }
    }


    //Languages Form Array
    addNewLanguagesFormArrayFieldBasedOnData(orgBasedOnboardFormsJson: OrgBasedOnboardForm, data) {
        // if (orgBasedOnboardFormsJson.languagesFieldIsRequired) {
        return this.formBuilder.group({
            // language: new FormControl(data.language, [Validators.pattern(validationConstants.REGEX_TEXT_TYPE1), Validators.maxLength(30)]),
            language: new FormControl(data.language, [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(30)]),
            read: new FormControl(data.read),
            write: new FormControl(data.write),
            speak: new FormControl(data.speak),
        });
        // }
        // else {
        //     return this.formBuilder.group({
        //         language: new FormControl(data.language, [Validators.pattern(validationConstants.REGEX_TEXT_TYPE1), Validators.maxLength(30)]),
        //         read: new FormControl(data.read),
        //         write: new FormControl(data.write),
        //         speak: new FormControl(data.speak),
        //     });
        // }
    }


    //Education Form Array 
    addNewEducationFormArrayField(orgBasedOnboardFormsJson: OrgBasedOnboardForm) {
        return this.formBuilder.group({
            id: new FormControl(null),
            degreename: new FormControl('', [Validators.required]),
            specialization: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
            percent: new FormControl(null, [Validators.pattern(validationConstants.REGEX_DECIMAL_TYPE4), Validators.maxLength(5)]),
            university: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(60)]),
            yearofpassing: new FormControl(null, [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(4)]),
            type: new FormControl(''),
            status: new FormControl(''),
        });

        // if (orgBasedOnboardFormsJson.educationFieldIsRequired) {
        //     return this.formBuilder.group({
        //         id: new FormControl(null),
        //         degreename: new FormControl('', [Validators.required]),
        //         specialization: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
        //         percent: new FormControl(null, [Validators.pattern(validationConstants.REGEX_DECIMAL_TYPE4), Validators.required, Validators.maxLength(5)]),
        //         university: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(60)]),
        //         yearofpassing: new FormControl(null, [Validators.required, Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(4)]),
        //         type: new FormControl('', [Validators.required]),
        //         status: new FormControl(''),
        //     });
        // }
        // else {
        //     return this.formBuilder.group({
        //         id: new FormControl(null),
        //         degreename: new FormControl(''),
        //         specialization: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
        //         percent: new FormControl(null, [Validators.pattern(validationConstants.REGEX_DECIMAL_TYPE4), Validators.maxLength(5)]),
        //         university: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(60)]),
        //         yearofpassing: new FormControl(null, [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(4)]),
        //         type: new FormControl(''),
        //         status: new FormControl(''),
        //     });
        // }
    }

    addNewEducationFieldBasedOnData(orgBasedOnboardFormsJson: OrgBasedOnboardForm,data) {
        return this.formBuilder.group({
            id: new FormControl(data.id),
            degreename: new FormControl(data.degreename, [Validators.required]),
            specialization: new FormControl(data.specialization, [Validators.maxLength(50)]),
            percent: new FormControl(data.percent, [Validators.pattern(validationConstants.REGEX_DECIMAL_TYPE4), Validators.maxLength(5)]),
            university: new FormControl(data.university, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(60)]),
            yearofpassing: new FormControl(data.yearofpassing, [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(4)]),
            type: new FormControl(data.type),
            status: new FormControl(''),
        });

        // if (orgBasedOnboardFormsJson.educationFieldIsRequired) {
        //     return this.formBuilder.group({
        //         id: new FormControl(data.id),
        //         degreename: new FormControl(data.degreename, [Validators.required]),
        //         specialization: new FormControl(data.specialization, [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
        //         percent: new FormControl(data.percent, [Validators.pattern(validationConstants.REGEX_DECIMAL_TYPE4), Validators.required, Validators.maxLength(5)]),
        //         university: new FormControl(data.university, [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(60)]),
        //         yearofpassing: new FormControl(data.yearofpassing, [Validators.required, Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(4)]),
        //         type: new FormControl(data.type, [Validators.required]),
        //         status: new FormControl(''),
        //     });
        // }
        // else {
        //     return this.formBuilder.group({
        //         id: new FormControl(data.id),
        //         degreename: new FormControl(data.degreename),
        //         specialization: new FormControl(data.specialization, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
        //         percent: new FormControl(data.percent, [Validators.pattern(validationConstants.REGEX_DECIMAL_TYPE4), Validators.maxLength(5)]),
        //         university: new FormControl(data.university, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(60)]),
        //         yearofpassing: new FormControl(data.yearofpassing, [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(4)]),
        //         type: new FormControl(data.type),
        //         status: new FormControl(''),
        //     });
        // }
    }

    //Experience Form Array
    addNewExperienceFormArrayField(orgBasedOnboardFormsJson: OrgBasedOnboardForm, preferredcurrency) {
        return this.formBuilder.group({
            id: new FormControl(null),
            organization: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50), Validators.required]),
            designation: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
            startdt: new FormControl(''),
            enddt: new FormControl(''),
            ctcvaluestring: new FormControl('', [Validators.maxLength(10)]),
            ctcvalue: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(18)]),
            ctctype: new FormControl(preferredcurrency),
            type: new FormControl(''),
            status: new FormControl(''),
            // location: new FormControl('', [Validators.required]),
            // address: new FormControl('', [Validators.required])
        });

        // if (orgBasedOnboardFormsJson.experienceFieldIsRequired) {
        //     return this.formBuilder.group({
        //         id: new FormControl(null),
        //         organization: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]),
        //         designation: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
        //         startdt: new FormControl('', [Validators.required]),
        //         enddt: new FormControl('', [Validators.required]),
        //         ctcvalue: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(18)]),
        //         ctctype: new FormControl(preferredcurrency, [Validators.required]),
        //         type: new FormControl('', [Validators.required]),
        //         status: new FormControl(''),
        //         // location: new FormControl('', [Validators.required]),
        //         // address: new FormControl('', [Validators.required])
        //     });
        // }
        // else {
        //     return this.formBuilder.group({
        //         id: new FormControl(null),
        //         organization: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]),
        //         designation: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
        //         startdt: new FormControl(''),
        //         enddt: new FormControl(''),
        //         ctcvalue: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(18)]),
        //         ctctype: new FormControl(preferredcurrency),
        //         type: new FormControl(''),
        //         status: new FormControl(''),
        //         // location: new FormControl(''),
        //         // address: new FormControl('')
        //     });
        // }
    }

    addNewExperienceFieldBasedOnData(orgBasedOnboardFormsJson: OrgBasedOnboardForm, data) {
        return this.formBuilder.group({
            id: new FormControl(data.id),
            organization: new FormControl(data.organization, [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50), Validators.required]),
            designation: new FormControl(data.designation, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
            startdt: new FormControl(data.startdt),
            enddt: new FormControl(data.enddt),
            // ctcvaluestring: new FormControl(data.ctcvaluestring, [Validators.maxLength(10)]),
            ctcvalue: new FormControl(data.ctcvalue, [Validators.pattern(validationConstants.REGEX_DECIMAL_TYPE4), Validators.maxLength(8)]),
            ctctype: new FormControl(data.ctctype),
            type: new FormControl(data.type),
            status: new FormControl(''),
        });

        // if (orgBasedOnboardFormsJson.experienceFieldIsRequired) {
        //     return this.formBuilder.group({
        //         id: new FormControl(data.id),
        //         organization: new FormControl(data.organization, [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]),
        //         designation: new FormControl(data.designation, [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
        //         startdt: new FormControl(data.startdt, [Validators.required]),
        //         enddt: new FormControl(data.enddt, [Validators.required]),
        //         // ctcvalue: new FormControl(data.ctcvalue, [Validators.required, Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(18)]),
        //         ctcvalue: new FormControl(data.ctcvaluestring, [Validators.pattern(validationConstants.REGEX_DECIMAL_TYPE4), Validators.maxLength(8)]),
        //         ctctype: new FormControl(data.ctctype, [Validators.required]),
        //         type: new FormControl(data.type, [Validators.required]),
        //         status: new FormControl(''),
        //         // location: new FormControl('', [Validators.required]),
        //         // address: new FormControl('', [Validators.required])
        //     });
        // }
        // else {
        //     return this.formBuilder.group({
        //         id: new FormControl(data.id),
        //         organization: new FormControl(data.organization, [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]),
        //         designation: new FormControl(data.designation, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
        //         startdt: new FormControl(data.startdt),
        //         enddt: new FormControl(data.enddt),
        //         ctcvalue: new FormControl(data.ctcvalue, [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(18)]),
        //         ctctype: new FormControl(data.ctctype, [Validators.required]),
        //         type: new FormControl(data.type),
        //         status: new FormControl(''),
        //         // location: new FormControl(''),
        //         // address: new FormControl('')
        //     });
        // }
    }

    //Skill Form Array
    addNewSkillFormArrayField(orgBasedCandidateFormJson: OrgBasedOnboardForm) {
        return this.formBuilder.group({
            id: new FormControl(null),
            skill: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50), Validators.required]),
            version: new FormControl('', []),
            yrsworked: new FormControl(''),
            lastused: new FormControl(''),
            proficiency: new FormControl('', []),
            status: new FormControl('', []),
        });
    }

    addNewSkillFormArrayFieldBasedOnData(orgBasedCandidateFormJson: OrgBasedOnboardForm, data) {
        return this.formBuilder.group({
            id: new FormControl(data.id),
            skill: new FormControl(data.skill, [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50), Validators.required]),
            version: new FormControl(data.version, []),
            yrsworked: new FormControl(data.yrsworked),
            lastused: new FormControl(data.lastused),
            proficiency: new FormControl(data.proficiency, []),
            status: new FormControl('', []),
        });
    }

    //Reference Form Array
    addNewReferenceFormArrayField(orgBasedOnboardFormsJson: OrgBasedOnboardForm) {
        //   return this.formBuilder.group({
        //       name: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
        //       designation: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
        //       organization: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]),
        //       relationtype: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
        //     dialcode: new FormControl(''),
        //     mobilenumber: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(15)]),
        //     contact: new FormControl(''),
        //       email: new FormControl('', [Validators.required, Validators.email])
        // });

        if (orgBasedOnboardFormsJson.referencesFieldIsRequired) {
            return this.formBuilder.group({
                name: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                designation: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                organization: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]),
                relationtype: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                dialcode: new FormControl(''),
                mobilenumber: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.minLength(4), Validators.maxLength(15)]),
                contact: new FormControl(''),
                email: new FormControl('', [Validators.required, Validators.email])
            });
        }
        else {
            return this.formBuilder.group({
                name: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                designation: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                organization: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]),
                relationtype: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                dialcode: new FormControl(''),
                mobilenumber: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.minLength(4), Validators.maxLength(15)]),
                contact: new FormControl(''),
                email: new FormControl('', [Validators.email])
            });
        }

    }

    // orgBasedOnboardFormsJson: OrgBasedOnboardForm,
    addNewReferenceFormArrayFieldBasedOnData(data) {
        // if (orgBasedOnboardFormsJson.referencesFieldIsRequired) {
        //     return this.formBuilder.group({
        //         name: new FormControl(data.name, [Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
        //         designation: new FormControl(data.designation, [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
        //         organization: new FormControl(data.organization, [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]),
        //         relationtype: new FormControl(data.relationtype, [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
        //         dialcode: new FormControl(''),
        //         mobilenumber: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.minLength(4), Validators.maxLength(15)]),
        //         contact: new FormControl(data.contact),
        //         email: new FormControl(data.email, [Validators.required, Validators.email])
        //     });
        // }
        // else {
        return this.formBuilder.group({
            name: new FormControl(data.name, [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
            designation: new FormControl(data.designation, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
            organization: new FormControl(data.organization, [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]),
            relationtype: new FormControl(data.relationtype, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
            dialcode: new FormControl(''),
            mobilenumber: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.minLength(4), Validators.maxLength(15)]),
            contact: new FormControl(data.contact),
            email: new FormControl(data.email, [Validators.email])
        });
        // }
    }

    //Siblings Form Array
    addNewSiblingsFormArrayField(orgBasedOnboardFormsJson: OrgBasedOnboardForm) {
        if (orgBasedOnboardFormsJson.siblingsFieldIsRequired) {
            return this.formBuilder.group({
                name: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                dob: new FormControl('', [Validators.required]),
                gender: new FormControl('', [Validators.required]),
                address: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)])
            });
        }
        else {
            return this.formBuilder.group({
                name: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                dob: new FormControl(''),
                gender: new FormControl(''),
                address: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)])
            });
        }
    }

    addNewSiblingsFormArrayFieldBasedOnData(orgBasedOnboardFormsJson: OrgBasedOnboardForm, data) {
        if (orgBasedOnboardFormsJson.siblingsFieldIsRequired) {
            return this.formBuilder.group({
                name: new FormControl(data.name, [Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                dob: new FormControl(data.dob, [Validators.required]),
                gender: new FormControl(data.gender, [Validators.required]),
                address: new FormControl(data.address, [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)])
            });
        }
        else {
            return this.formBuilder.group({
                name: new FormControl(data.name, [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                dob: new FormControl(data.dob),
                gender: new FormControl(data.gender),
                address: new FormControl(data.address, [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)])
            });
        }
    }

    //Children Form Array
    addNewChildrenFormArrayField(orgBasedOnboardFormsJson: OrgBasedOnboardForm,) {
        if (orgBasedOnboardFormsJson.childrenFieldIsRequired) {
            return this.formBuilder.group({
                name: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                dob: new FormControl('', [Validators.required]),
                gender: new FormControl('', [Validators.required]),
                address: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)])
            });
        }
        else {
            return this.formBuilder.group({
                name: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                dob: new FormControl(''),
                gender: new FormControl(''),
                address: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)])
            });
        }
    }

    addNewChildrenFormArrayFieldBasedOnData(orgBasedOnboardFormsJson: OrgBasedOnboardForm, data) {
        if (orgBasedOnboardFormsJson.childrenFieldIsRequired) {
            return this.formBuilder.group({
                name: new FormControl(data.name, [Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                dob: new FormControl(data.dob, [Validators.required]),
                gender: new FormControl(data.gender, [Validators.required]),
                address: new FormControl(data.address, [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)])
            });
        }
        else {
            return this.formBuilder.group({
                name: new FormControl(data.name, [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                dob: new FormControl(data.dob),
                gender: new FormControl(data.gender),
                address: new FormControl(data.address, [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)])
            });
        }
    }

    //Relative Form Array
    addNewRelativeFormArrayField(orgBasedOnboardFormsJson: OrgBasedOnboardForm, dialcode) {
        if (orgBasedOnboardFormsJson.decrelworkFieldIsRequired) {
            return this.formBuilder.group({
                name: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                empid: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(20)]),
                designation: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                email: new FormControl('', [Validators.required, Validators.email]),
                dialcode: new FormControl(dialcode),
                mobilenumber: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.minLength(4), Validators.maxLength(15)]),
                mobino: new FormControl(''),
                location: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                department: new FormControl('', [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
            });
        }
        else {
            return this.formBuilder.group({
                name: new FormControl('', [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                empid: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(20)]),
                designation: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                email: new FormControl('', [Validators.email]),
                dialcode: new FormControl(dialcode),
                mobilenumber: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.minLength(4), Validators.maxLength(15)]),
                mobino: new FormControl(''),
                location: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                department: new FormControl('', [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
            });
        }
    }

    addNewRelativeFormArrayFieldBasedOnData(orgBasedOnboardFormsJson: OrgBasedOnboardForm, data) {
        // if (orgBasedOnboardFormsJson.decrelworkFieldIsRequired) {
        //     return this.formBuilder.group({
        //         name: new FormControl(data.name, [Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
        //         empid: new FormControl(data.empid, [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(20)]),
        //         designation: new FormControl(data.designation, [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
        //         email: new FormControl(data.email, [Validators.required, Validators.email]),
        //         dialcode: new FormControl(''),
        //         mobilenumber: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.minLength(4), Validators.maxLength(15)]),
        //         mobino: new FormControl(data.mobino),
        //         location: new FormControl(data.location, [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
        //         department: new FormControl(data.department, [Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
        //     });
        // }
        // else {
            return this.formBuilder.group({
                name: new FormControl(data.name, [Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]),
                empid: new FormControl(data.empid, [Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(20)]),
                designation: new FormControl(data.designation, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                email: new FormControl(data.email, [Validators.email]),
                dialcode: new FormControl(''),
                mobilenumber: new FormControl('', [Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.minLength(4), Validators.maxLength(15)]),
                mobino: new FormControl(data.mobino),
                location: new FormControl(data.location, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
                department: new FormControl(data.department, [Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]),
            });
        // }
    }

    updateDynamicValidation(orgBasedOnboardFormsJson: OrgBasedOnboardForm, onboardCreateForm: FormGroup) {
        //salutation 
        if (orgBasedOnboardFormsJson.salutationFieldIsRequired) {
            onboardCreateForm.get('salutation').setValidators([Validators.required]);
            onboardCreateForm.get('salutation').updateValueAndValidity()
        }
        else {
            onboardCreateForm.get('salutation').setValidators([]);
            onboardCreateForm.get('salutation').updateValueAndValidity()
        }
        // firstname
        if (orgBasedOnboardFormsJson.firstnameFieldIsRequired) {
            onboardCreateForm.get('firstname').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(30)]);
            onboardCreateForm.get('firstname').updateValueAndValidity()
        }
        else {
            onboardCreateForm.get('firstname').setValidators([Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(30)]);
            onboardCreateForm.get('firstname').updateValueAndValidity()
        }
        // middlename
        if (orgBasedOnboardFormsJson.middlenameFieldIsRequired) {
            onboardCreateForm.get('middlename').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(30)]);
            onboardCreateForm.get('middlename').updateValueAndValidity()
        }
        else {
            onboardCreateForm.get('middlename').setValidators([Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(30)]);
            onboardCreateForm.get('middlename').updateValueAndValidity()
        }
        // lastname
        if (orgBasedOnboardFormsJson.lastnameFieldIsRequired) {
            onboardCreateForm.get('lastname').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(30)]);
            onboardCreateForm.get('lastname').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('lastname').setValidators([Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(30)]);
            onboardCreateForm.get('lastname').updateValueAndValidity();
        }
        // gender
        if (orgBasedOnboardFormsJson.genderFieldIsRequired) {
            onboardCreateForm.get('gender').setValidators([Validators.required]);
            onboardCreateForm.get('gender').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('gender').setValidators([]);
            onboardCreateForm.get('gender').updateValueAndValidity();
        }
        //maritalstatus 
        if (orgBasedOnboardFormsJson.maritalstatusFieldIsRequired) {
            onboardCreateForm.get('maritalstatus').setValidators([Validators.required]);
            onboardCreateForm.get('maritalstatus').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('maritalstatus').setValidators([]);
            onboardCreateForm.get('maritalstatus').updateValueAndValidity();
        }
        // dob
        if (orgBasedOnboardFormsJson.dobFieldIsRequired) {
            onboardCreateForm.get('dob').setValidators([Validators.required]);
            onboardCreateForm.get('dob').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('dob').setValidators([]);
            onboardCreateForm.get('dob').updateValueAndValidity();
        }
        // age
        if (orgBasedOnboardFormsJson.ageFieldIsRequired) {
            onboardCreateForm.get('age').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.max(60)]);
            onboardCreateForm.get('age').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('age').setValidators([Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.max(60)]);
            onboardCreateForm.get('age').updateValueAndValidity();
        }
        // nationality
        if (orgBasedOnboardFormsJson.nationalityFieldIsRequired) {
            onboardCreateForm.get('nationality').setValidators([Validators.required]);
            onboardCreateForm.get('nationality').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('nationality').setValidators([]);
            onboardCreateForm.get('nationality').updateValueAndValidity();
        }
        // email
        if (orgBasedOnboardFormsJson.emailFieldIsRequired) {
            onboardCreateForm.get('email').setValidators([Validators.required, Validators.email]);
            onboardCreateForm.get('email').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('email').setValidators([Validators.email]);
            onboardCreateForm.get('email').updateValueAndValidity();
        }
        //mobino 
        if (orgBasedOnboardFormsJson.mobinoFieldIsRequired) {
            onboardCreateForm.get('mobilenumber').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(15), Validators.minLength(4)]);
            onboardCreateForm.get('mobilenumber').updateValueAndValidity();
            onboardCreateForm.get('dialcode').setValidators([Validators.required]);
            onboardCreateForm.get('dialcode').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('mobilenumber').setValidators([Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(15), Validators.minLength(4)]);
            onboardCreateForm.get('mobilenumber').updateValueAndValidity();
            onboardCreateForm.get('dialcode').setValidators([]);
            onboardCreateForm.get('dialcode').updateValueAndValidity();
        }
        // altermobino
        if (orgBasedOnboardFormsJson.altmobinoFieldIsRequired) {
            onboardCreateForm.get('altmobilenumber').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(15), Validators.minLength(4)]);
            onboardCreateForm.get('altmobilenumber').updateValueAndValidity();
            onboardCreateForm.get('altdialcode').setValidators([Validators.required]);
            onboardCreateForm.get('altdialcode').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('altmobilenumber').setValidators([Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(15), Validators.minLength(4)]);
            onboardCreateForm.get('altmobilenumber').updateValueAndValidity();
            onboardCreateForm.get('altdialcode').setValidators([]);
            onboardCreateForm.get('altdialcode').updateValueAndValidity();
        }
        // bloodgroup
        if (orgBasedOnboardFormsJson.bloodgroupFieldIsRequired) {
            onboardCreateForm.get('bloodgroup').setValidators([Validators.required]);
            onboardCreateForm.get('bloodgroup').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('bloodgroup').setValidators([]);
            onboardCreateForm.get('bloodgroup').updateValueAndValidity();
        }
        // hobbies
        if (orgBasedOnboardFormsJson.hobbiesFieldIsRequired) {
            onboardCreateForm.get('hobbies').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(20)]);
            onboardCreateForm.get('hobbies').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('hobbies').setValidators([Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(20)]);
            onboardCreateForm.get('hobbies').updateValueAndValidity();
        }
        //ssn number
        if (orgBasedOnboardFormsJson.ssnFieldIsRequired) {
            onboardCreateForm.get('identity').get('ssn_no').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(9)]);
            onboardCreateForm.get('identity').get('ssn_no').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('identity').get('ssn_no').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(9)]);
            onboardCreateForm.get('identity').get('ssn_no').updateValueAndValidity();
        }
        //passport number
        if (orgBasedOnboardFormsJson.passportFieldIsRequired) {
            onboardCreateForm.get('identity').get('passport_no').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(9)]);
            onboardCreateForm.get('identity').get('passport_no').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('identity').get('passport_no').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(9)]);
            onboardCreateForm.get('identity').get('passport_no').updateValueAndValidity();
        }
        //pancard number
        if (orgBasedOnboardFormsJson.pancardFieldIsRequired) {
            onboardCreateForm.get('identity').get('pancard_no').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(10)]);
            onboardCreateForm.get('identity').get('pancard_no').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('identity').get('pancard_no').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(10)]);
            onboardCreateForm.get('identity').get('pancard_no').updateValueAndValidity();
        }
        //drivinglicense_no number
        if (orgBasedOnboardFormsJson.drivinglicenseFieldIsRequired) {
            onboardCreateForm.get('identity').get('drivinglicense_no').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(16)]);
            onboardCreateForm.get('identity').get('drivinglicense_no').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('identity').get('drivinglicense_no').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(16)]);
            onboardCreateForm.get('identity').get('drivinglicense_no').updateValueAndValidity();
        }
        //bankname
        if (orgBasedOnboardFormsJson.banknameFieldIsRequired) {
            onboardCreateForm.get('bank').get('bankname_1').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6)]);
            onboardCreateForm.get('bank').get('bankname_1').updateValueAndValidity();
            onboardCreateForm.get('bank').get('bankname_2').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6)]);
            onboardCreateForm.get('bank').get('bankname_2').updateValueAndValidity();
            onboardCreateForm.get('bank').get('bankname_3').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6)]);
            onboardCreateForm.get('bank').get('bankname_3').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('bank').get('bankname_1').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6)]);
            onboardCreateForm.get('bank').get('bankname_1').updateValueAndValidity();

            onboardCreateForm.get('bank').get('bankname_2').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6)]);
            onboardCreateForm.get('bank').get('bankname_2').updateValueAndValidity();

            onboardCreateForm.get('bank').get('bankname_3').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6)]);
            onboardCreateForm.get('bank').get('bankname_3').updateValueAndValidity();
        }
        //bankaccountno
        if (orgBasedOnboardFormsJson.bankaccnoFieldIsRequired) {
            onboardCreateForm.get('bank').get('bankaccountno_1').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(30), Validators.minLength(5)]);
            onboardCreateForm.get('bank').get('bankaccountno_1').updateValueAndValidity();
            onboardCreateForm.get('bank').get('bankaccountno_2').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(30), Validators.minLength(5)]);
            onboardCreateForm.get('bank').get('bankaccountno_2').updateValueAndValidity();
            onboardCreateForm.get('bank').get('bankaccountno_3').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(30), Validators.minLength(5)]);
            onboardCreateForm.get('bank').get('bankaccountno_3').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('bank').get('bankaccountno_1').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(30), Validators.minLength(5)]);
            onboardCreateForm.get('bank').get('bankaccountno_1').updateValueAndValidity();
            onboardCreateForm.get('bank').get('bankaccountno_2').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(30), Validators.minLength(5)]);
            onboardCreateForm.get('bank').get('bankaccountno_2').updateValueAndValidity();
            onboardCreateForm.get('bank').get('bankaccountno_3').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(30), Validators.minLength(5)]);
            onboardCreateForm.get('bank').get('bankaccountno_3').updateValueAndValidity();
        }
        //ifsc_code
        if (orgBasedOnboardFormsJson.bankifscFieldIsRequired) {
            onboardCreateForm.get('bank').get('ifsc_code_1').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(11)]);
            onboardCreateForm.get('bank').get('ifsc_code_1').updateValueAndValidity();
            onboardCreateForm.get('bank').get('ifsc_code_2').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(11)]);
            onboardCreateForm.get('bank').get('ifsc_code_2').updateValueAndValidity();
            onboardCreateForm.get('bank').get('ifsc_code_3').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(11)]);
            onboardCreateForm.get('bank').get('ifsc_code_3').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('bank').get('ifsc_code_1').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(11)]);
            onboardCreateForm.get('bank').get('ifsc_code_1').updateValueAndValidity();
            onboardCreateForm.get('bank').get('ifsc_code_2').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(11)]);
            onboardCreateForm.get('bank').get('ifsc_code_2').updateValueAndValidity();
            onboardCreateForm.get('bank').get('ifsc_code_3').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(11)]);
            onboardCreateForm.get('bank').get('ifsc_code_3').updateValueAndValidity();
        }
        //curaddline1
        if (orgBasedOnboardFormsJson.curaddline1FieldIsRequired) {
            onboardCreateForm.get('curaddline1').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(30)]);
            onboardCreateForm.get('curaddline1').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('curaddline1').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(30)]);
            onboardCreateForm.get('curaddline1').updateValueAndValidity();
        }
        //curaddline2
        if (orgBasedOnboardFormsJson.curaddline2FieldIsRequired) {
            onboardCreateForm.get('curaddline2').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]);
            onboardCreateForm.get('curaddline2').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('curaddline2').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]);
            onboardCreateForm.get('curaddline2').updateValueAndValidity();
        }
        //permaddline1
        if (orgBasedOnboardFormsJson.permaddline1FieldIsRequired) {
            onboardCreateForm.get('permaddline1').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(30)]);
            onboardCreateForm.get('permaddline1').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('permaddline1').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(30)]);
            onboardCreateForm.get('permaddline1').updateValueAndValidity();
        }
        //permaddline2
        if (orgBasedOnboardFormsJson.permaddline2FieldIsRequired) {
            onboardCreateForm.get('permaddline2').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]);
            onboardCreateForm.get('permaddline2').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('permaddline2').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(50)]);
            onboardCreateForm.get('permaddline2').updateValueAndValidity();
        }
        //curtcity
        if (orgBasedOnboardFormsJson.curtcityFieldIsRequired) {
            onboardCreateForm.get('curtcity').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(100)]);
            onboardCreateForm.get('curtcity').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('curtcity').setValidators([Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(100)]);
            onboardCreateForm.get('curtcity').updateValueAndValidity();
        }
        //permcity
        if (orgBasedOnboardFormsJson.permcityFieldIsRequired) {
            onboardCreateForm.get('permcity').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(100)]);
            onboardCreateForm.get('permcity').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('permcity').setValidators([Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(100)]);
            onboardCreateForm.get('permcity').updateValueAndValidity();
        }
        //curcountry
        if (orgBasedOnboardFormsJson.curcountryFieldIsRequired) {
            onboardCreateForm.get('curcountry').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(50)]);
            onboardCreateForm.get('curcountry').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('curcountry').setValidators([Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(50)]);
            onboardCreateForm.get('curcountry').updateValueAndValidity();
        }
        //permcountry
        if (orgBasedOnboardFormsJson.permcountryFieldIsRequired) {
            onboardCreateForm.get('permcountry').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(50)]);
            onboardCreateForm.get('permcountry').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('permcountry').setValidators([Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(50)]);
            onboardCreateForm.get('permcountry').updateValueAndValidity();
        }
        //curtstate
        if (orgBasedOnboardFormsJson.curtstateFieldIsRequired) {
            onboardCreateForm.get('curtstate').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(100)]);
            onboardCreateForm.get('curtstate').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('curtstate').setValidators([Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(100)]);
            onboardCreateForm.get('curtstate').updateValueAndValidity();
        }
        //permstate
        if (orgBasedOnboardFormsJson.permstateFieldIsRequired) {
            onboardCreateForm.get('permstate').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(100)]);
            onboardCreateForm.get('permstate').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('permstate').setValidators([Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(100)]);
            onboardCreateForm.get('permstate').updateValueAndValidity();
        }
        //curpin
        if (orgBasedOnboardFormsJson.curpinFieldIsRequired) {
            onboardCreateForm.get('curpin').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(10), Validators.minLength(4)]);
            onboardCreateForm.get('curpin').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('curpin').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(10), Validators.minLength(4)]);
            onboardCreateForm.get('curpin').updateValueAndValidity();
        }
        //permpin
        if (orgBasedOnboardFormsJson.permpinFieldIsRequired) {
            onboardCreateForm.get('permpin').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(10), Validators.minLength(4)]);
            onboardCreateForm.get('permpin').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('permpin').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE6), Validators.maxLength(10), Validators.minLength(4)]);
            onboardCreateForm.get('permpin').updateValueAndValidity();
        }
        //father
        if (orgBasedOnboardFormsJson.fatherFieldIsRequired) {
            onboardCreateForm.get('family').get('father_name').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]);
            onboardCreateForm.get('family').get('father_name').updateValueAndValidity();
            onboardCreateForm.get('family').get('father_dob').setValidators([Validators.required]);
            onboardCreateForm.get('family').get('father_dob').updateValueAndValidity();
            onboardCreateForm.get('family').get('father_gender').setValidators([Validators.required]);
            onboardCreateForm.get('family').get('father_gender').updateValueAndValidity();
            onboardCreateForm.get('family').get('father_address').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)]);
            onboardCreateForm.get('family').get('father_address').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('family').get('father_name').setValidators([Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]);
            onboardCreateForm.get('family').get('father_name').updateValueAndValidity();
            onboardCreateForm.get('family').get('father_dob').setValidators([]);
            onboardCreateForm.get('family').get('father_dob').updateValueAndValidity();
            onboardCreateForm.get('family').get('father_gender').setValidators([]);
            onboardCreateForm.get('family').get('father_gender').updateValueAndValidity();
            onboardCreateForm.get('family').get('father_address').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)]);
            onboardCreateForm.get('family').get('father_address').updateValueAndValidity();
        }
        //mother
        if (orgBasedOnboardFormsJson.motherFieldIsRequired) {
            onboardCreateForm.get('family').get('mother_name').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]);
            onboardCreateForm.get('family').get('mother_name').updateValueAndValidity();
            onboardCreateForm.get('family').get('mother_dob').setValidators([Validators.required]);
            onboardCreateForm.get('family').get('mother_dob').updateValueAndValidity();
            onboardCreateForm.get('family').get('mother_gender').setValidators([Validators.required]);
            onboardCreateForm.get('family').get('mother_gender').updateValueAndValidity();
            onboardCreateForm.get('family').get('mother_address').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)]);
            onboardCreateForm.get('family').get('mother_address').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('family').get('mother_name').setValidators([Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]);
            onboardCreateForm.get('family').get('mother_name').updateValueAndValidity();
            onboardCreateForm.get('family').get('mother_dob').setValidators([]);
            onboardCreateForm.get('family').get('mother_dob').updateValueAndValidity();
            onboardCreateForm.get('family').get('mother_gender').setValidators([]);
            onboardCreateForm.get('family').get('mother_gender').updateValueAndValidity();
            onboardCreateForm.get('family').get('mother_address').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)]);
            onboardCreateForm.get('family').get('mother_address').updateValueAndValidity();
        }
        //spouse
        if (orgBasedOnboardFormsJson.spouseFieldIsRequired) {
            onboardCreateForm.get('family').get('spouse_name').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]);
            onboardCreateForm.get('family').get('spouse_name').updateValueAndValidity()
            onboardCreateForm.get('family').get('spouse_dob').setValidators([Validators.required]);
            onboardCreateForm.get('family').get('spouse_dob').updateValueAndValidity()
            onboardCreateForm.get('family').get('spouse_gender').setValidators([Validators.required]);
            onboardCreateForm.get('family').get('spouse_gender').updateValueAndValidity()
            onboardCreateForm.get('family').get('spouse_address').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)]);
            onboardCreateForm.get('family').get('spouse_address').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('family').get('spouse_name').setValidators([Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]);
            onboardCreateForm.get('family').get('spouse_name').updateValueAndValidity();
            onboardCreateForm.get('family').get('spouse_dob').setValidators([]);
            onboardCreateForm.get('family').get('spouse_dob').updateValueAndValidity();
            onboardCreateForm.get('family').get('spouse_gender').setValidators([]);
            onboardCreateForm.get('family').get('spouse_gender').updateValueAndValidity();
            onboardCreateForm.get('family').get('spouse_address').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)]);
            onboardCreateForm.get('family').get('spouse_address').updateValueAndValidity();
        }
        //inlaws
        if (orgBasedOnboardFormsJson.inlawsFieldIsRequired) {
            onboardCreateForm.get('family').get('fatherinlaw_name').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]);
            onboardCreateForm.get('family').get('fatherinlaw_name').updateValueAndValidity();
            onboardCreateForm.get('family').get('fatherinlaw_dob').setValidators([Validators.required]);
            onboardCreateForm.get('family').get('fatherinlaw_dob').updateValueAndValidity();
            onboardCreateForm.get('family').get('fatherinlaw_gender').setValidators([Validators.required]);
            onboardCreateForm.get('family').get('fatherinlaw_gender').updateValueAndValidity();
            onboardCreateForm.get('family').get('fatherinlaw_address').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)]);
            onboardCreateForm.get('family').get('fatherinlaw_address').updateValueAndValidity();
            onboardCreateForm.get('family').get('motherinlaw_name').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]);
            onboardCreateForm.get('family').get('motherinlaw_name').updateValueAndValidity();
            onboardCreateForm.get('family').get('motherinlaw_dob').setValidators([Validators.required]);
            onboardCreateForm.get('family').get('motherinlaw_dob').updateValueAndValidity();
            onboardCreateForm.get('family').get('motherinlaw_gender').setValidators([Validators.required]);
            onboardCreateForm.get('family').get('motherinlaw_gender').updateValueAndValidity();
            onboardCreateForm.get('family').get('motherinlaw_address').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)]);
            onboardCreateForm.get('family').get('motherinlaw_address').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('family').get('fatherinlaw_name').setValidators([Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]);
            onboardCreateForm.get('family').get('fatherinlaw_name').updateValueAndValidity();
            onboardCreateForm.get('family').get('fatherinlaw_dob').setValidators([]);
            onboardCreateForm.get('family').get('fatherinlaw_dob').updateValueAndValidity();
            onboardCreateForm.get('family').get('fatherinlaw_gender').setValidators([]);
            onboardCreateForm.get('family').get('fatherinlaw_gender').updateValueAndValidity();
            onboardCreateForm.get('family').get('fatherinlaw_address').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)]);
            onboardCreateForm.get('family').get('fatherinlaw_address').updateValueAndValidity();
            onboardCreateForm.get('family').get('motherinlaw_name').setValidators([Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]);
            onboardCreateForm.get('family').get('motherinlaw_name').updateValueAndValidity();
            onboardCreateForm.get('family').get('motherinlaw_dob').setValidators([]);
            onboardCreateForm.get('family').get('motherinlaw_dob').updateValueAndValidity();
            onboardCreateForm.get('family').get('motherinlaw_gender').setValidators([]);
            onboardCreateForm.get('family').get('motherinlaw_gender').updateValueAndValidity();
            onboardCreateForm.get('family').get('motherinlaw_address').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)]);
            onboardCreateForm.get('family').get('motherinlaw_address').updateValueAndValidity();
        }
        //emecontactname
        if (orgBasedOnboardFormsJson.emecontactnameFieldIsRequired) {
            onboardCreateForm.get('emecontactname').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]);
            onboardCreateForm.get('emecontactname').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('emecontactname').setValidators([Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]);
            onboardCreateForm.get('emecontactname').updateValueAndValidity();
        }
        //emerel
        if (orgBasedOnboardFormsJson.emerelFieldIsRequired) {
            onboardCreateForm.get('emerel').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]);
            onboardCreateForm.get('emerel').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('emerel').setValidators([Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]);
            onboardCreateForm.get('emerel').updateValueAndValidity();
        }
        //emenum
        if (orgBasedOnboardFormsJson.emenumFieldIsRequired) {
            onboardCreateForm.get('emedialcode').setValidators([Validators.required]);
            onboardCreateForm.get('emedialcode').updateValueAndValidity();

            onboardCreateForm.get('ememobilenumber').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.minLength(4), Validators.maxLength(15)]);
            onboardCreateForm.get('ememobilenumber').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('emedialcode').setValidators([]);
            onboardCreateForm.get('emedialcode').updateValueAndValidity();

            onboardCreateForm.get('ememobilenumber').setValidators([Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.minLength(4), Validators.maxLength(15)]);
            onboardCreateForm.get('ememobilenumber').updateValueAndValidity();
        }
        // decworkprev
        if (orgBasedOnboardFormsJson.decworkprevFieldIsRequired) {
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('empid').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(20)]);
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('empid').updateValueAndValidity();
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('designation').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]);
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('designation').updateValueAndValidity();
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('ctc').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(18)]);
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('ctc').updateValueAndValidity();
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('ctctype').setValidators([Validators.required]);
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('ctctype').updateValueAndValidity();
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('dateofrelieving').setValidators([Validators.required]);
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('dateofrelieving').updateValueAndValidity();
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('reason').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]);
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('reason').updateValueAndValidity();
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_name').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]);
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_name').updateValueAndValidity();
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_empid').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(20)]);
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_empid').updateValueAndValidity();
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_designation').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]);
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_designation').updateValueAndValidity();
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_email').setValidators([Validators.required, Validators.email]);
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_email').updateValueAndValidity();
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_mobilenumber').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(15), Validators.minLength(4)]);
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_mobilenumber').updateValueAndValidity();
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_dialcode').setValidators([Validators.required]);
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_dialcode').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('empid').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(20)]);
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('empid').updateValueAndValidity();
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('designation').setValidators([Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]);
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('designation').updateValueAndValidity();
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('ctc').setValidators([Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(18)]);
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('ctc').updateValueAndValidity();
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('dateofrelieving').setValidators([]);
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('dateofrelieving').updateValueAndValidity();
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('reason').setValidators([Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]);
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('reason').updateValueAndValidity();
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_name').setValidators([Validators.pattern(validationConstants.REGEX_TEXT_TYPE2), Validators.maxLength(90)]);
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_name').updateValueAndValidity();
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_empid').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(20)]);
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_empid').updateValueAndValidity();
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_designation').setValidators([Validators.pattern(validationConstants.REGEX_ALPHA_TYPE7), Validators.maxLength(50)]);
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_designation').updateValueAndValidity();
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_email').setValidators([Validators.email]);
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_email').updateValueAndValidity();
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_mobilenumber').setValidators([Validators.pattern(validationConstants.REGEX_INTEGER_TYPE3), Validators.maxLength(15), Validators.minLength(4)]);
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_mobilenumber').updateValueAndValidity();
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_dialcode').setValidators([]);
            onboardCreateForm.get('declaration').get('workedpreviouslydetails').get('supervisor_dialcode').updateValueAndValidity();
        }
        // decmedi
        if (orgBasedOnboardFormsJson.decmediFieldIsRequired) {
            onboardCreateForm.get('declaration').get('medicalailmentsdetails').get('description').setValidators([Validators.required, Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)]);
            onboardCreateForm.get('declaration').get('medicalailmentsdetails').get('description').updateValueAndValidity();
        }
        else {
            onboardCreateForm.get('declaration').get('medicalailmentsdetails').get('description').setValidators([Validators.pattern(validationConstants.REGEX_ALPHANUMERIC_TYPE5), Validators.maxLength(250)]);
            onboardCreateForm.get('declaration').get('medicalailmentsdetails').get('description').updateValueAndValidity();
        }
        // //update value and validity 
        onboardCreateForm.updateValueAndValidity();
        return onboardCreateForm;
    }


    downloadFile(filesrc, filename) {
        // constructing the blob 
        var fileString = filesrc.replace(FileConstants.REPLACE_STRING, '')
        // Converting and setting to createObjectURL
        var file = new Blob([this.convertBase64ToArrayBuffer(fileString)], { type: 'application/pdf' })
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        var a = document.createElement('a');
        a.href = fileURL;
        a.target = '_blank';
        a.download = filename ? filename : 'File' + '.pdf';
        document.body.appendChild(a);
        a.click();
    }

    convertBase64ToArrayBuffer(base64) {
        var binary_string = base64.replace(/\\n/g, '');
        binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    }
}
